import _objectSpread from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorValues from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regeneratorValues.js";
import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue";
var _hoisted_1 = {
  class: "app-list"
};
var _hoisted_2 = {
  class: "title-div"
};
var _hoisted_3 = {
  class: "title-right"
};
var _hoisted_4 = {
  class: "app-list-content"
};
var _hoisted_5 = {
  key: 0,
  class: "app-list-component"
};
var _hoisted_6 = ["onClick"];
var _hoisted_7 = {
  key: 0,
  class: "app-content component-content"
};
var _hoisted_8 = ["onClick"];
var _hoisted_9 = {
  class: "app-div",
  style: {
    "width": "100%",
    "height": "100%"
  }
};
var _hoisted_10 = {
  key: 0,
  class: "app-loading"
};
var _hoisted_11 = {
  key: 1,
  class: "app-content"
};
var _hoisted_12 = ["onClick"];
var _hoisted_13 = {
  key: 2,
  class: "app-empty"
};
import SortDialog from './AppSortDialog.vue';
import DisTimeDialog from '../../Common/DisTimeDialog.vue';
import AppItem from './AppItem.vue';
import DataView from './DataView.vue';
import CommonApp from './CommonApp.vue';
import Group from './Group.vue';
import { MessagePlugin } from 'tdesign-vue-next';
import { SearchIcon } from 'tdesign-icons-vue-next';
import { getAppBubbleByAlias, getAppUsable, getAppGroup, getAppComponent, delAppComponent, useApp } from '@/api/home.js';
import { skipUrl as skipUrlOpen } from '@/util/util';
import { JumpToThird } from '@/util/thridExtends';
import { useRouter } from 'vue-router';
import { getStore, setStore } from '@/util/store';
import { routeAuth, appAliasInfo } from '@/utils/auth';
import useNIMStore from '@/stores/modules/nim';
import { computed, watch, ref, onMounted } from 'vue';
export default {
  __name: 'AppList',
  props: {
    role: {
      type: String,
      default: 'manager'
    }
  },
  setup: function setup(__props) {
    var props = __props;
    /**
     * 当前页面
     */
    var componentObj = {
      1: DataView,
      2: CommonApp,
      3: Group
    };
    var userInfo = getStore({
      name: 'userInfo'
    }); // 获取userInfo
    var accessToken = getStore({
      name: 'access_token'
    }); // 获取accessToken
    var router = useRouter();
    var useNIM = useNIMStore();

    // 初始化相关
    var appList = ref([]); // 应用列表
    // 问答应用(chatQa)红点数：云信初始化同步完成后才展示，避免本地缓存的过期未读数误报
    var unread = computed(function () {
      return useNIM.qaUnread;
    });
    var searchKeyword = ref('');
    var hasSearched = ref(false);

    // 搜索过滤应用列表
    var handleSearch = function handleSearch() {
      hasSearched.value = true;
    };
    var handleClear = function handleClear() {
      searchKeyword.value = '';
      hasSearched.value = false;
    };
    var filteredAppList = computed(function () {
      var list = [];
      if (appComponentList.value.length) {
        var _appComponentList$val;
        ((_appComponentList$val = appComponentList.value) === null || _appComponentList$val === void 0 ? void 0 : _appComponentList$val.length) === 2 ? list = appList.value : list = appList.value.slice(6, appList.value.length);
      } else {
        list = appList.value;
      }
      if (!hasSearched.value) return list;
      if (!searchKeyword.value) return list;
      var keyword = searchKeyword.value.toLowerCase();
      return appList.value.filter(function (item) {
        return item.appDetail.name.toLowerCase().includes(keyword);
      });
    });
    watch(function () {
      return searchKeyword.value;
    }, function (val) {
      if (!val) hasSearched.value = false;
    });
    /**
     * 应用排序
     */
    var sortVisible = ref(false); // 应用排序弹窗显隐

    /**
     * 跳转app
     */
    var disVisible = ref(false);
    var appId = ref(null);

    /**
     * 获取应用列表
     */
    var appLoading = ref(false);
    var getAppList = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _res$data, code, data, _resData$find, resData, list, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              appLoading.value = true;
              _context.n = 1;
              return getAppGroup();
            case 1:
              res = _context.v;
              _res$data = res.data, code = _res$data.code, data = _res$data.data;
              if (!(code === 0)) {
                _context.n = 2;
                break;
              }
              resData = data || [];
              list = ((_resData$find = resData.find(function (i) {
                return i.type === props.role;
              })) === null || _resData$find === void 0 ? void 0 : _resData$find.list) || [];
              setStore({
                name: 'userAppList',
                content: resData,
                type: 'session'
              });
              _context.n = 2;
              return getPopNum(list);
            case 2:
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              MessagePlugin.error((_t === null || _t === void 0 ? void 0 : _t.message) || '应用获取失败');
            case 4:
              return _context.a(2);
          }
        }, _callee, null, [[0, 3]]);
      }));
      return function getAppList() {
        return _ref.apply(this, arguments);
      };
    }();
    /**
     * 获取气泡数量
     */
    var getPopNum = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(list) {
        var apps, res, _res$data2, code, data, tempData, _loop, index, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              if (list.length) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              apps = list.map(function (i) {
                return i.appDetail.alias;
              });
              _context3.n = 2;
              return getAppBubbleByAlias(apps);
            case 2:
              res = _context3.v;
              _res$data2 = res.data, code = _res$data2.code, data = _res$data2.data;
              if (!(code === 0)) {
                _context3.n = 5;
                break;
              }
              appList.value = [];
              tempData = data || [];
              _loop = /*#__PURE__*/_regenerator().m(function _loop() {
                var _list$index, appDetail, useOfTimeControl, appItem, popItem, useState, isNew, num;
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      _list$index = list[index], appDetail = _list$index.appDetail, useOfTimeControl = _list$index.useOfTimeControl;
                      appItem = {
                        appDetail: appDetail,
                        useOfTimeControl: useOfTimeControl,
                        showNotUse: false,
                        isNew: false,
                        num: 0
                      };
                      popItem = tempData.find(function (i) {
                        return i.alias === appDetail.alias;
                      });
                      if (popItem) {
                        useState = popItem.useState, isNew = popItem.isNew, num = popItem.num;
                        appItem.showNotUse = !useState;
                        appItem.isNew = isNew;
                        appItem.num = num > 99 ? '99+' : num;
                      }
                      appList.value.push(appItem);
                    case 1:
                      return _context2.a(2);
                  }
                }, _loop);
              });
              index = 0;
            case 3:
              if (!(index < list.length)) {
                _context3.n = 5;
                break;
              }
              return _context3.d(_regeneratorValues(_loop()), 4);
            case 4:
              index++;
              _context3.n = 3;
              break;
            case 5:
              _context3.n = 7;
              break;
            case 6:
              _context3.p = 6;
              _t2 = _context3.v;
              console.log(_t2);
            case 7:
              _context3.p = 7;
              appLoading.value = false;
              return _context3.f(7);
            case 8:
              return _context3.a(2);
          }
        }, _callee2, null, [[0, 6, 7, 8]]);
      }));
      return function getPopNum(_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    // 事件相关
    var changeSort = function changeSort() {
      sortVisible.value = true;
    };
    var handleOpenApp = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(appDetail) {
        var res, _res$data3, code, data;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (!appDetail.showNotUse) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              if (!appDetail.useOfTimeControl) {
                _context4.n = 3;
                break;
              }
              _context4.n = 2;
              return getAppUsable(appDetail.id);
            case 2:
              res = _context4.v;
              _res$data3 = res.data, code = _res$data3.code, data = _res$data3.data;
              if (!(code === 0 && !data)) {
                _context4.n = 3;
                break;
              }
              // 应用不可用
              appId.value = appDetail.id;
              disVisible.value = true;
              return _context4.a(2);
            case 3:
              if (appDetail.source === 0) {
                useApp({
                  appId: appDetail.id
                });
                if (appDetail.alias === 'inspirationCentre') {
                  skipUrlOpen(appDetail.url + '?inspirationCentre=%2Fsub-inspiration-centre-svc%2Fcourse');
                } else {
                  skipUrlOpen(appDetail.url);
                }
              } else {
                useApp({
                  appId: appDetail.id
                });
                JumpToThird(appDetail, userInfo.value, accessToken, function (alias) {
                  if (alias.includes('boxiao')) {
                    router.push("/".concat(alias));
                  }
                });
              }
            case 4:
              return _context4.a(2);
          }
        }, _callee3);
      }));
      return function handleOpenApp(_x2) {
        return _ref3.apply(this, arguments);
      };
    }();

    // 小组件
    var appComponentList = ref([]);
    var getAppComponentList = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res, groupAuth, _yield$appAliasInfo, hasAuth, auth, dataAuth, index, obj, _res$data4, code, data, _t3;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              _context5.n = 1;
              return getAppComponent();
            case 1:
              res = _context5.v;
              _context5.n = 2;
              return routeAuth('groupsSpace');
            case 2:
              groupAuth = _context5.v;
              _context5.n = 3;
              return appAliasInfo('dataView');
            case 3:
              _yield$appAliasInfo = _context5.v;
              hasAuth = _yield$appAliasInfo.hasAuth;
              auth = _yield$appAliasInfo.auth;
              dataAuth = false;
              if (hasAuth && auth) {
                index = auth.findIndex(function (itm) {
                  return itm.permission.includes('interactiveData');
                });
                dataAuth = index > -1;
              }
              obj = {
                1: dataAuth,
                3: groupAuth,
                2: true
              };
              _res$data4 = res.data, code = _res$data4.code, data = _res$data4.data;
              if (code === 0) {
                appComponentList.value = data.filter(function (i) {
                  return obj[i.type];
                }).sort(function (a, b) {
                  return new Date(b.createTime) - new Date(a.createTime);
                }) || [];
                console.log('appComponentList', appComponentList.value, data);
              }
              _context5.n = 5;
              break;
            case 4:
              _context5.p = 4;
              _t3 = _context5.v;
              console.error('获取小组件列表失败:', _t3);
            case 5:
              return _context5.a(2);
          }
        }, _callee4, null, [[0, 4]]);
      }));
      return function getAppComponentList() {
        return _ref4.apply(this, arguments);
      };
    }();
    // 移除小组件
    var handleDelete = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(item) {
        var res;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              item.showPopuop = false;
              _context6.n = 1;
              return delAppComponent({
                type: item.type
              });
            case 1:
              res = _context6.v;
              if (res.data.code === 0) {
                MessagePlugin.success("\u79FB\u9664\u6210\u529F");
                getAppComponentList();
              }
            case 2:
              return _context6.a(2);
          }
        }, _callee5);
      }));
      return function handleDelete(_x3) {
        return _ref5.apply(this, arguments);
      };
    }();
    var refreshPage = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return getAppComponentList();
            case 1:
              _context7.n = 2;
              return getAppList();
            case 2:
              return _context7.a(2);
          }
        }, _callee6);
      }));
      return function refreshPage() {
        return _ref6.apply(this, arguments);
      };
    }();
    onMounted(function () {
      refreshPage();
    });
    return function (_ctx, _cache) {
      var _filteredAppList$valu, _filteredAppList$valu2, _filteredAppList$valu3;
      var _component_t_input = _resolveComponent("t-input");
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_t_popup = _resolveComponent("t-popup");
      var _component_t_loading = _resolveComponent("t-loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "title-left"
      }, [_createElementVNode("span", {
        class: "right-8"
      }, "工作台")], -1)), _createElementVNode("div", _hoisted_3, [_createVNode(_component_t_input, {
        modelValue: searchKeyword.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return searchKeyword.value = $event;
        }),
        placeholder: "请输入应用名称",
        clearable: "",
        class: "search-input",
        onInput: handleSearch,
        onEnter: handleSearch,
        onClear: handleClear
      }, {
        suffixIcon: _withCtx(function () {
          return [_createVNode(_unref(SearchIcon), {
            style: {
              cursor: 'pointer'
            },
            onClick: handleSearch
          })];
        }),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_svg_icon, {
        name: "setting",
        onClick: changeSort
      })])]), _createElementVNode("div", _hoisted_4, [appComponentList.value.length && !hasSearched.value ? (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appComponentList.value, function (item) {
        return _openBlock(), _createElementBlock("div", {
          key: item.id,
          class: "component-div"
        }, [_createVNode(_component_t_popup, {
          placement: "bottom-right",
          trigger: "click",
          destroyOnClose: ""
        }, {
          content: _withCtx(function () {
            return [_createElementVNode("div", {
              class: "delete-btn",
              onClick: function onClick($event) {
                return handleDelete(item);
              }
            }, "移除组件", 8, _hoisted_6)];
          }),
          default: _withCtx(function () {
            return [_createVNode(_component_svg_icon, {
              name: "delete-icon",
              size: "18",
              class: "delete-icon"
            })];
          }),
          _: 2
        }, 1024), (_openBlock(), _createBlock(_resolveDynamicComponent(componentObj[item.type])))]);
      }), 128)), appComponentList.value.length !== 2 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appList.value.slice(0, 6), function (_ref7, index) {
        var appDetail = _ref7.appDetail,
          useOfTimeControl = _ref7.useOfTimeControl,
          isNew = _ref7.isNew,
          showNotUse = _ref7.showNotUse,
          num = _ref7.num;
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["item-card", {
            not: showNotUse
          }]),
          onClick: function onClick($event) {
            return handleOpenApp(_objectSpread(_objectSpread({}, appDetail), {}, {
              showNotUse: showNotUse,
              useOfTimeControl: useOfTimeControl
            }));
          }
        }, [_createVNode(AppItem, {
          data: {
            appDetail: appDetail,
            useOfTimeControl: useOfTimeControl,
            isNew: isNew,
            showNotUse: showNotUse,
            num: num,
            unread: unread.value
          }
        }, null, 8, ["data"])], 10, _hoisted_8);
      }), 128))])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_9, [appLoading.value && !((_filteredAppList$valu = filteredAppList.value) !== null && _filteredAppList$valu !== void 0 && _filteredAppList$valu.length) ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_t_loading)])) : _createCommentVNode("", true), !appLoading.value && (_filteredAppList$valu2 = filteredAppList.value) !== null && _filteredAppList$valu2 !== void 0 && _filteredAppList$valu2.length ? (_openBlock(), _createElementBlock("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredAppList.value, function (_ref8, index) {
        var appDetail = _ref8.appDetail,
          useOfTimeControl = _ref8.useOfTimeControl,
          isNew = _ref8.isNew,
          showNotUse = _ref8.showNotUse,
          num = _ref8.num;
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["item-card", {
            not: showNotUse
          }]),
          onClick: function onClick($event) {
            return handleOpenApp(_objectSpread(_objectSpread({}, appDetail), {}, {
              showNotUse: showNotUse,
              useOfTimeControl: useOfTimeControl
            }));
          }
        }, [_createVNode(AppItem, {
          data: {
            appDetail: appDetail,
            useOfTimeControl: useOfTimeControl,
            isNew: isNew,
            showNotUse: showNotUse,
            num: num,
            unread: unread.value
          }
        }, null, 8, ["data"])], 10, _hoisted_12);
      }), 128))])) : _createCommentVNode("", true), !appLoading.value && !((_filteredAppList$valu3 = filteredAppList.value) !== null && _filteredAppList$valu3 !== void 0 && _filteredAppList$valu3.length) ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(hasSearched.value ? '暂无相关应用，你可尝试更换搜索词' : '暂无应用'), 1)) : _createCommentVNode("", true)])]), _createVNode(SortDialog, {
        sortVisible: sortVisible.value,
        "onUpdate:sortVisible": _cache[1] || (_cache[1] = function ($event) {
          return sortVisible.value = $event;
        }),
        "tab-type": __props.role,
        onRefresh: refreshPage
      }, null, 8, ["sortVisible", "tab-type"]), _createVNode(DisTimeDialog, {
        disVisible: disVisible.value,
        "onUpdate:disVisible": _cache[2] || (_cache[2] = function ($event) {
          return disVisible.value = $event;
        }),
        appId: appId.value
      }, null, 8, ["disVisible", "appId"])]);
    };
  }
};